
































import Vue from 'vue'

import { SingleActions } from '@/shared/Actions'

import SingleAdmin from '@/components/SingleAdmin.vue'
import Spinner from '@/components/Spinner.vue'
import { Admin } from '@/models/Admin'

export default Vue.extend({
  components: {
    SingleAdmin,
    Spinner
  },
  computed: {
    admins(): Admin[] {
      return this.$store.state.admins.filter((it: Admin) => it.isAccepted === true)
    },
    adminRequests(): Admin[] {
      return this.$store.state.admins.filter((it: Admin) => it.isAccepted === false)
    }
  },
  mounted() {
    this.$store.dispatch(SingleActions.FETCH_ALL_ADMINS)
  },
  methods: {
    async acceptAdmin(email: string) {
      this.$confirm(
        `Jesteś pewnien, że chcesz zezwolić użytkownikowi ${email} na dostęp do systemu?`,
        'Potwierdzenie',
        {
          confirmButtonText: 'Tak',
          cancelButtonText: 'Nie',
          type: 'success'
        }
      ).then(() => {
        this.$store.dispatch('acceptAdmin', email)
      })
    },
    async removeAdmin(email: string) {
      this.$confirm(`Jesteś pewnien, że chcesz usunąć administratora ${email}?`, 'Potwierdzenie', {
        confirmButtonText: 'Tak',
        cancelButtonText: 'Nie',
        type: 'error'
      }).then(() => {
        this.$store.dispatch('removeAdmin', email)
      })
    },
    async rejectAdmin(email: string) {
      this.$confirm(
        `Jesteś pewnien, że chcesz odrzucić prośbę użytkownika ${email} o dostęp do systemu?`,
        'Potwierdzenie',
        {
          confirmButtonText: 'Tak',
          cancelButtonText: 'Nie',
          type: 'error'
        }
      ).then(() => {
        this.$store.dispatch('removeAdmin', email)
      })
    }
  }
})
